package com.yogaaicoach.pages.insights.data

import com.yogaaicoach.common.network.ApiClient
import io.ktor.http.*

class InsightsApi(private val client: ApiClient) {

    suspend fun getInsights(): GetInsightsResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/insights",
            method = HttpMethod.Get,
        )
    }
}
